import React, { useEffect, useState } from "react";
import { ArrowRight, Leaf } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { Button } from "../../components/ui/button";

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section
      style={{
        padding: "5rem 1.5rem",
        background: "rgba(0, 0, 0, 0.02)",
      }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2
          style={{
            fontWeight: 600,
            fontSize: "clamp(1.875rem, 4vw, 3rem)",
            lineHeight: 0.95,
            letterSpacing: "-0.015em",
            color: "rgb(0, 55, 32)",
            marginBottom: "1.5rem",
          }}
        >
          {t.about.title}
        </h2>
        <p
          style={{
            fontSize: "clamp(1.125rem, 2.5vw, 1.25rem)",
            lineHeight: 1.6,
            color: "rgb(14, 15, 12)",
            marginBottom: "3rem",
          }}
        >
          {t.about.description}
        </p>
      </div>
    </section>
  );
};

export default Hero;
